<div class="d-flex flex-row">
    <div class="px-w-60">
        <span>{{fromText}}</span>
    </div>
    <div class="px-w-40">to</div>
    <div class="px-w-85">
        <select [(ngModel)]="timeRangeTail.to" class="form-control me-sm-2 form-control-sm form-select form-select-sm"
            (ngModelChange)="onToChange($event)">
            <option *ngFor="let item of timeRangeList" [ngValue]="item.value">{{item.text}}</option>
        </select>
    </div>
    <div class="px-w-75">
        <select [(ngModel)]="timeRangeTail.tail" class="form-control me-sm-2 form-control-sm form-select form-select-sm">
            <option *ngFor="let tail of tailValues" [ngValue]="tail">{{tail * 100}}</option>
        </select>
    </div>
    <div class="px-w-35">%</div>
    <div class="px-w-35">
        <div *ngIf="tailIndex > 0" class="logo-btn-small close" (click)="onRemoveTimeRangeTail()"></div>
    </div>
</div>
